/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartPastHistoryInactivateAliases {
  BUTTON_MODAL_CANCEL = 'button-modal-cancel',
  BUTTON_MODAL_INACTIVATE = 'button-modal-inactivate',
  FIELD_REASON_INACTIVATE = 'field-reason-inactivate',
  FORM_INACTIVATE_PAST_HISTORY = 'form-inactivate-past-history',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INPUT_REASON_INACTIVATE = 'input-reason-inactivate',
  LAYOUT_PAST_HISTORY_INACTIVATE = 'layout-past-history-inactivate',
  PANEL_CONTENT_INACTIVATE_PAST_HISTORY = 'panel-content-inactivate-past-history',
}
export { MyChartPastHistoryInactivateAliases };
